export enum ADDRESS_TYPE {
  PRINCIPAL = 'PRINCIPAL',
  JOB = 'JOB',
}

export enum ADDRESS_TYPE_CODE {
  HOME = '100',
  JOB = '101',
}
